'use strict';

angular.module('atex.dam').controller('DamDropdownController', [ '$scope', function($scope) {
  if ($scope.selectedValue) {
    $scope.selectedOption = _.find($scope.array, function(item) {
      return item[$scope.fieldValue] === $scope.selectedValue;
    });
  }
} ]);

angular.module('atex.dam').directive('damDropdown', function() {
  return {
    restrict : 'E',

    templateUrl : 'js/dam/widgets/dam-dropdown/dam-dropdown.html',

    replace : true,

    scope : {
      label : '@',
      array : '=',
      fieldLabel : '@',
      fieldValue : '@',
      selectedValue : '=',
      selectCallBack : '&'
    },

    controller : 'DamDropdownController',

    link : function(scope, element, attrs) {
      scope.$watch(function() {
        return scope.selectedValue;
      }, function(newValue, oldValue) {
        if (scope.selectedValue !== undefined) {
          scope.selectedOption = _.find(scope.array, function(item) {
            return item[scope.fieldValue] === scope.selectedValue;
          });
        }
      });
    }
  };
});
